module.exports = {
          srcSet: __webpack_public_path__ + "public/f11d635ec09ec48cdb05c826567939b3-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/f11d635ec09ec48cdb05c826567939b3-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/f11d635ec09ec48cdb05c826567939b3-40.png",
          toString:function(){return __webpack_public_path__ + "public/f11d635ec09ec48cdb05c826567939b3-40.png"},
          
          width: 40,
          height: 40
        }